module.exports = __webpack_public_path__ + "static/img/fmImg.021245b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fmImg.png
// module id = sINR
// module chunks = 1